//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Cell, CellGroup } from 'vant'
export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  data () {
    return {
      isExpand: false
    }
  },
  created () {
    this.$vux.loading.hide()
  },
  methods: {
    perNor: function (event) {
//    this.$router.push({path: '/guide/confirm/perNor'})
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/confirm/perNor'}, function (data) {
        console.log('functionSecelted')
      })
    },
    perEmp: function (event) {
//    this.$router.push({path: '/guide/confirm/perEmp'})
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/confirm/perEmp'}, function (data) {
        console.log('functionSecelted')
      })
    },
    perPro: function (event) {
//    this.$router.push({path: '/guide/confirm/perPro'})
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/confirm/perPro'}, function (data) {
        console.log('functionSecelted')
      })
    },
    orgNor: function (event) {
//    this.$router.push({path: '/guide/confirm/orgNor'})
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/confirm/orgNor'}, function (data) {
        console.log('functionSecelted')
      })
    },
    orgPro: function (event) {
//    this.$router.push({path: '/guide/confirm/orgPro'})
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/confirm/orgPro'}, function (data) {
        console.log('functionSecelted')
      })
    },
    orgSelf: function (event) {
//    this.$router.push({path: '/guide/confirm/orgSelf'})
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/confirm/orgSelf'}, function (data) {
        console.log('functionSecelted')
      })
    },
    orgFin: function (event) {
//    this.$router.push({path: '/guide/confirm/orgFin'})
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/confirm/orgFin'}, function (data) {
        console.log('functionSecelted')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Guide/Confirm/confirmListGuide.vue